<script setup lang="ts">
const props = defineProps({
    option: {
        type: String,
        default: "",
        required: true,
    },
});

const flags: Record<string, boolean> = {
    durationSlider: !!+import.meta.env.VITE_FEATURE_TOGGLE_DURATION_SLIDER,
    destinationAutocomplete: !!+import.meta.env
        .VITE_FEATURE_TOGGLE_DESTINATION_AUTOCOMPLETE,
    datePicker: !!+import.meta.env.VITE_FEATURE_TOGGLE_DATEPICKER,
    searchBarV1: !!+import.meta.env.VITE_FEATURE_TOGGLE_SEARCHBAR_V1,
    searchBarV2: !!+import.meta.env.VITE_FEATURE_TOGGLE_SEARCHBAR_V2,
};
</script>
<template>
    <slot v-if="flags[props.option]"></slot>
</template>
